import { OmniCluster, OmniClusterPhase } from '@cast/types-omni';

export const isClusterOmniEnabled = (cluster?: OmniCluster | null): boolean => {
  return cluster?.status?.phase === OmniClusterPhase.READY;
};
